// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"aaa179aa","204":"c7998fc3","243":"ea05e904"}[chunkId] + ".chunk.js";
};